import React from "react";
import { PatientPortalForm } from "../../components/patientPortalForm/PatientPortalForm";

export const PatientPortalPage = () => {
  return <PatientPortalForm />;
};
